var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-review-page"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-12"
  }, [_vm.isLoading ? _c('b-skeleton-table', {
    attrs: {
      "rows": 8,
      "columns": 1
    }
  }) : _vm.loadError ? _c('div', {
    staticClass: "review-thanks text-center"
  }, [_c('h2', [_vm._v("We couldn't load your enrollment")]), _c('p', [_vm._v("Please check your connection and try again.")]), _c('button', {
    staticClass: "submitSignature",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.load
    }
  }, [_vm._v("Try again")])]) : _vm.submitted ? _c('div', {
    staticClass: "review-thanks text-center"
  }, [_c('h2', [_vm._v("Thank you")]), _c('p', [_vm._v("Your review has been submitted. You can close this page.")])]) : _c('div', {
    ref: "tabsCard",
    staticClass: "page-card enrollmentEdit-card"
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function ($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Information Details",
      "active": ""
    }
  }, [_c('b-card-text', [_c('plan-summary'), _c('info-details', {
    on: {
      "saved": _vm.nextTab,
      "next": _vm.nextTab
    }
  })], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Contact Details"
    }
  }, [_c('b-card-text', [_c('contact-info', {
    on: {
      "saved": _vm.nextTab,
      "next": _vm.nextTab
    }
  })], 1)], 1), _vm._l(_vm.visibleTabs, function (tab, tabPosition) {
    return _c('b-tab', {
      key: tab.tab_name,
      attrs: {
        "title": _vm.getTabName(tab.tab_name),
        "disabled": tabPosition > _vm.pregnancyBlockedAfter
      }
    }, [_c('b-card-text', [_c(_vm.tabComponents[tab.tab_name], {
      tag: "component",
      on: {
        "saved": _vm.nextTab,
        "next": _vm.nextTab,
        "pregnancy-restricted": function ($event) {
          return _vm.setPregnancyRestricted(tab.tab_name, $event);
        }
      }
    })], 1)], 1);
  }), _c('b-tab', {
    attrs: {
      "title": "Billing Information",
      "disabled": _vm.isPregnancyRestricted
    }
  }, [_c('b-card-text', [_c('billing-info', {
    on: {
      "saved": _vm.nextTab,
      "next": _vm.nextTab
    }
  })], 1)], 1), _vm.agreements.length ? _c('b-tab', {
    attrs: {
      "title": "Agreement",
      "disabled": _vm.isPregnancyRestricted
    }
  }, [_c('b-card-text', [_c('agreement-info', {
    attrs: {
      "texts": _vm.agreements
    },
    on: {
      "next": _vm.nextTab
    }
  })], 1)], 1) : _vm._e(), _c('b-tab', {
    attrs: {
      "title": "Review & Sign",
      "disabled": _vm.isPregnancyRestricted
    }
  }, [_c('b-card-text', [_c('review-and-sign', {
    on: {
      "submitted": function ($event) {
        _vm.submitted = true;
      }
    }
  })], 1)], 1)], 2)], 1)], 1)], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Review Your Enrollment")])])]);

}]

export { render, staticRenderFns }